export default "__VITE_ASSET__BbH2zP$I__"